import { select, put, takeLatest } from 'redux-saga/effects';
import { UserMessage, ConversationAPI } from 'api/conversations';
import { StoreActionProps } from 'data/core';
import { updateCommentAction } from '../actions';
import { getComment, selectConversation } from '../selectors';
import { updateComment } from '../slices';
import { CommentActionPayload } from '../types';

function* updateCommentSaga({
  payload,
}: StoreActionProps<CommentActionPayload<UserMessage>>) {
  const { comment, context } = payload;
  const { projectId } = yield select(selectConversation(context));
  const commentToUpdate = yield select(getComment(context, comment.commentId));

  try {
    yield put(
      updateComment({
        comment,
        context,
      }),
    );
    yield ConversationAPI.updateComment(
      projectId,
      context,
      comment.commentId,
      comment,
    );
  } catch (error) {
    yield put(
      updateComment({
        comment: commentToUpdate,
        context,
      }),
    );
  }
}

export const watchUpdateCommentSaga = function* (): Generator {
  yield takeLatest(updateCommentAction.type, updateCommentSaga);
};
